<div class="row d-none d-md-block mx-3 mt-2 pt-4">
    <div class="col">
        <ol class="breadcrumb p-0 m-0">
            <li *ngFor="let breadcrumb of breadcrumbs; let i = index; let max = last">
                <span *ngIf="i > 0" class="icon mx-2"><i class="icon-edponline-arrow-right" aria-hidden="true"></i></span>
                <a *ngIf="!max && breadcrumb.externalLink" href="{{breadcrumb.externalLink}}" class="breadcrumb-font-link">{{breadcrumb.label | translate}}</a>
                <a *ngIf="!max && !breadcrumb.externalLink" [routerLink]="[breadcrumb.routeLink, breadcrumb.params]" class="breadcrumb-font-link">{{breadcrumb.label | translate}}</a>
                <span *ngIf="max" class="breadcrumb-font">{{breadcrumb.label | translate}}</span>
            </li>
        </ol>
    </div>
</div>